$(document)
	.on('change keyup keydown paste cut click', 'textarea', function () {
		$(this).outerHeight(0).outerHeight(this.scrollHeight);
	}).find('textarea').change()